import LooksOneIcon from "@mui/icons-material/LooksOne";
import LooksTwoIcon from "@mui/icons-material/LooksTwo";
import Looks3Icon from "@mui/icons-material/Looks3";
import Looks4Icon from "@mui/icons-material/Looks4";
import Looks5Icon from "@mui/icons-material/Looks5";
import Looks6Icon from "@mui/icons-material/Looks6";
import { Box, List, ListItem, ListItemIcon, Typography } from "@mui/material";
import { RoleComponentGuard } from "../Guards/RoleComponentGuard";
import { useTranslation } from "react-i18next";
import { Role } from "../../../types/enums";

export default function AddLocalCoordinatorIntro() {
  const { t } = useTranslation();
  return (
    <>
      <Box>
        <Typography variant="h5">
          {t("introductions.addLocalCoordinator.header")}
        </Typography>
      </Box>
      <Box mt={3}>
        <Typography variant="body1">
          {t("introductions.addLocalCoordinator.text1")}
        </Typography>
      </Box>
      <Box mt={2}>
        <Typography variant="body1">
          {t("introductions.addLocalCoordinator.lcIs")}
        </Typography>
        <List
          disablePadding
          sx={{
            listStyleType: "disc",
            pl: 2,
            "& .MuiListItem-root": {
              display: "list-item",
            },
          }}
        >
          <ListItem disableGutters>
            <Typography variant="body1">
              {t("introductions.addLocalCoordinator.lcIs1")}
            </Typography>
          </ListItem>
          <ListItem disableGutters>
            <Typography variant="body1">
              {t("introductions.addLocalCoordinator.lcIs2")}
            </Typography>
          </ListItem>
          <ListItem disableGutters>
            <Typography variant="body1">
              {t("introductions.addLocalCoordinator.lcIs3")}
            </Typography>
          </ListItem>
        </List>
      </Box>
      <Box mt={3}>
        <Typography variant="body1">
          {t("introductions.addLocalCoordinator.text2")}
        </Typography>
      </Box>
      <RoleComponentGuard roles={[Role.PrecureAdmin, Role.SolutionOwner, Role.Partner]}>
        <Box mt={3}>
          <Typography variant="body1">
            {t("introductions.addLocalCoordinator.text3")}
          </Typography>
        </Box>
      </RoleComponentGuard>
      <Box mt={3}>
        <Typography variant="body1" color={"primary"}>
          {t("introductions.addLocalCoordinator.responsibilities")}
        </Typography>
      </Box>
      <List disablePadding>
        <ListItem disableGutters key={1}>
          <ListItemIcon>
            <LooksOneIcon color={"primary"} />
          </ListItemIcon>
          <Typography variant="body1">
            {t("introductions.addLocalCoordinator.responsibility1")}
          </Typography>
        </ListItem>
        <ListItem disableGutters key={2}>
          <ListItemIcon>
            <LooksTwoIcon color={"primary"} />
          </ListItemIcon>
          <Typography variant="body1">
            {t("introductions.addLocalCoordinator.responsibility2")}
          </Typography>
        </ListItem>
        <ListItem disableGutters key={3}>
          <ListItemIcon>
            <Looks3Icon color="primary" />
          </ListItemIcon>
          <Typography variant="body1">
            {t("introductions.addLocalCoordinator.responsibility3")}
          </Typography>
        </ListItem>
        <ListItem disableGutters key={4}>
          <ListItemIcon>
            <Looks4Icon color="primary" />
          </ListItemIcon>
          <Typography variant="body1">
            {t("introductions.addLocalCoordinator.responsibility4")}
          </Typography>
        </ListItem>
        <ListItem disableGutters key={5}>
          <ListItemIcon>
            <Looks5Icon color="primary" />
          </ListItemIcon>
          <Typography variant="body1">
            {t("introductions.addLocalCoordinator.responsibility5")}
          </Typography>
        </ListItem>
        <ListItem disableGutters key={6}>
          <ListItemIcon>
            <Looks6Icon color="primary" />
          </ListItemIcon>
          <Typography variant="body1">
            {t("introductions.addLocalCoordinator.responsibility6")}
          </Typography>
        </ListItem>
      </List>
    </>
  );
}
